export default __webpack_public_path__ + "static/media/font.02821153.woff2";